import {
  UPDATE_EVENT_REQUEST,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_FAILURE,
  RESET_EVENTS_STATE,
} from "../../../types/event";

const initialState = {
  loading: false,
  data: null,
  message: "",
  error: "",
  success: false,
};

const updateEventReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_EVENT_REQUEST:
      return {
        ...state,
        loading: true,
        message: "",
        error: "",
        success: false,
      };
    case UPDATE_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        message: "Event updated successfully",
        success: true,
      };
    case UPDATE_EVENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Failed to update event",
        success: false,
      };
    case RESET_EVENTS_STATE:
      return initialState;
    default:
      return state;
  }
};

export default updateEventReducer;
